import Parse from 'parse'
import Vue from 'vue'
import App from './App.vue'
import VueResource from 'vue-resource'
import router from './router'
import store from './store'
import AsyncComputed from 'vue-async-computed'
import * as Sentry from '@sentry/browser'
import { Vue as VueIntegration } from '@sentry/integrations'
import { i18n } from '@/locale'
import VueClipboard from 'vue-clipboard2'
import VueMatomo from 'vue-matomo'
import LoadScript from 'vue-plugin-load-script'
import moment from 'moment-timezone'
import { getLocaleFormat } from '../clavo-shared/functions/time.js'

Parse.initialize(process.env.VUE_APP_PARSE_SERVER_APPLICATION_ID, process.env.VUE_APP_PARSE_SERVER_API_KEY)
Parse.serverURL = process.env.VUE_APP_PARSE_SERVER_URL

if (process.env.VUE_APP_SENTRY_URL) {
  Sentry.init({
    dsn: process.env.VUE_APP_SENTRY_URL,
    integrations: [new VueIntegration({ Vue, attachProps: true })],
    logErrors: true,
  })
} else {
  console.log('Sentry not enabled.')
}

Object.getPrototypeOf(moment()).formatLocalized = function (format) {
  let i18Locale = i18n.locale
  let localeFormat = getLocaleFormat(format, i18Locale)
  return this.locale(i18Locale).format(localeFormat)
}

Vue.config.productionTip = false

function onError(error) {
  console.log('CLAVO ERROR', error)
}

Vue.config.errorHandler = (error) => onError(error)

Vue.use(VueResource)
Vue.use(AsyncComputed)
Vue.use(VueClipboard)
Vue.use(LoadScript)

navigator.who = (function () {
  var ua = navigator.userAgent
  var tem
  var M = ua.match(/(chrome|firefox|safari|opera|msie|trident(?=\/))\/?\s*(\d+)/i) || []
  if (/trident/i.test(M[1])) {
    tem = /\brv[ :]+(\d+)/g.exec(ua) || []
    return 'IE ' + (tem[1] || '')
  }
  if (M[1] === 'Chrome') {
    tem = ua.match(/\b(OPR|Edge)\/(\d+)/)
    if (tem != null) return tem.slice(1).join(' ').replace('OPR', 'Opera')
  }
  M = M[2] ? [M[1], M[2]] : [navigator.appName, navigator.appVersion, '-?']
  if ((tem = ua.match(/version\/(\d+)/i)) != null) M.splice(1, 1, tem[1])
  return M.join(' ')
})()

if (process.env.VUE_APP_MATOMO_ANALYTICS_SERVER_URL) {
  Vue.use(VueMatomo, {
    //https://www.npmjs.com/package/vue-matomo
    // Configure your matomo server and site by providing

    host: process.env.VUE_APP_MATOMO_ANALYTICS_SERVER_URL,
    siteId: 1,

    // Changes the default .js and .php endpoint's filename
    // Default: 'matomo'
    trackerFileName: 'matomo',

    // Overrides the autogenerated tracker endpoint entirely
    // Default: undefined
    // trackerUrl: 'https://example.com/whatever/endpoint/you/have',

    // Overrides the autogenerated tracker script path entirely
    // Default: undefined
    trackerScriptUrl: process.env.VUE_APP_MATOMO_JS_URL,

    // Enables automatically registering pageviews on the router
    router: router,

    // Enables link tracking on regular links. Note that this won't
    // work for routing links (ie. internal Vue router links)
    // Default: true
    enableLinkTracking: true,

    // Require consent before sending tracking information to matomo
    // Default: false
    requireConsent: false,

    // Whether to track the initial page view
    // Default: true
    trackInitialView: true,

    // Run Matomo without cookies
    // Default: false
    disableCookies: false,

    // Enable the heartbeat timer (https://developer.matomo.org/guides/tracking-javascript-guide#accurately-measure-the-time-spent-on-each-page)
    // Default: false
    enableHeartBeatTimer: false,

    // Set the heartbeat timer interval
    // Default: 15
    heartBeatTimerInterval: 15,

    // Whether or not to log debug information
    // Default: false
    debug: false,

    // UserID passed to Matomo (see https://developer.matomo.org/guides/tracking-javascript-guide#user-id)
    // Default: undefined
    userId: undefined,

    // Share the tracking cookie across subdomains (see https://developer.matomo.org/guides/tracking-javascript-guide#measuring-domains-andor-sub-domains)
    // Default: undefined, example '*.example.com'
    cookieDomain: '*.clavo.app',

    // Tell Matomo the website domain so that clicks on these domains are not tracked as 'Outlinks'
    // Default: undefined, example: '*.example.com'
    domains: '*.clavo.app',

    // A list of pre-initialization actions that run before matomo is loaded
    // Default: []
    // Example: [
    //   ['API_method_name', parameter_list],
    //   ['setCustomVariable','1','VisitorType','Member'],
    //   ['appendToTrackingUrl', 'new_visit=1'],
    //   etc.
    // ]
    preInitActions: [],
  })
}

new Vue({
  router,
  store,
  i18n,
  render: (h) => h(App),
}).$mount('#app')
